/*
  Patches two accessibility gaps in the Captain Protection shipping-protection
  toggle in the cart drawer. This is a third-party app widget, so we can't fix
  its source directly — this works around it from outside instead.

  Found via manual keyboard + NVDA testing:
  1. Toggling the switch (id="tm_switch_btn") re-renders it as a fresh DOM
     node, which drops keyboard focus back to <body> instead of keeping it
     on the control — forcing keyboard users to re-tab from the top of the
     page after every toggle.
  2. The cart total updates when the switch is toggled, but nothing
     announces that change to screen reader users — there's no aria-live
     region anywhere near it, so the price change happens silently for them.
*/
(function () {
  var SWITCH_ID = 'tm_switch_btn';
  var TOTAL_VALUE_SELECTOR = '.ocu-estimated-info__value';
  var LIVE_REGION_ID = 'captain-protection-a11y-announcer';
  var SETTLE_DELAY_MS = 300;

  function ensureLiveRegion() {
    var region = document.getElementById(LIVE_REGION_ID);
    if (region) return region;

    region = document.createElement('div');
    region.id = LIVE_REGION_ID;
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('role', 'status');
    region.style.position = 'absolute';
    region.style.width = '1px';
    region.style.height = '1px';
    region.style.overflow = 'hidden';
    region.style.clip = 'rect(0, 0, 0, 0)';
    region.style.whiteSpace = 'nowrap';
    document.body.appendChild(region);
    return region;
  }

  function announce() {
    var region = ensureLiveRegion();
    var freshSwitch = document.getElementById(SWITCH_ID);
    var checked = freshSwitch ? freshSwitch.checked : null;
    var totalEl = document.querySelector(TOTAL_VALUE_SELECTOR);
    var totalText = totalEl ? totalEl.textContent.trim() : '';
    var state = checked ? 'Shipping protection turned on.' : 'Shipping protection turned off.';

    // Clear first so two consecutive identical messages still both get
    // announced (some screen readers only speak on text-content changes).
    region.textContent = '';
    setTimeout(function () {
      region.textContent = state + (totalText ? ' Total updated to ' + totalText + '.' : '');
    }, 50);
  }

  function restoreFocusIfNeeded(wasFocused) {
    if (!wasFocused) return;
    var freshSwitch = document.getElementById(SWITCH_ID);
    if (freshSwitch && document.activeElement !== freshSwitch) {
      freshSwitch.focus();
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target.id !== SWITCH_ID) return;

    var wasFocused = document.activeElement === event.target;

    // Captain Protection re-renders the switch (and updates the total)
    // asynchronously after the change event fires, so both the focus
    // restore and the announcement need to wait for that to settle rather
    // than acting on stale/mid-update DOM.
    setTimeout(function () {
      restoreFocusIfNeeded(wasFocused);
      announce();
    }, SETTLE_DELAY_MS);
  }, true);
})();
